import React, { useState } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import { styled, alpha } from '@mui/material/styles';
import moment from 'moment';
import ViewWaiverLog from '../ViewWaiverLog';
import { AiFillEye } from 'react-icons/ai';
import { Box, IconButton } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 14,
  padding: 8,
  '&:first-of-type': {
    paddingLeft: 20,
  },
  '&:last-of-type': {
    paddingRight: 20,
  },
  '& .icon-btn': {
    border: `solid 1px ${alpha('#F84E4E', 1.0)}`,
    color: alpha('#F84E4E', 1.0),
    padding: 3,
    fontSize: 20,
    '&:not(:first-of-type)': {
      marginLeft: 8,
    },
  },
  '& .disable-icon-btn': {
    border: `solid 1px ${alpha('#b5ccd9', 1.0)}`,
    color: alpha('#b5ccd9', 1.0),
    padding: 3,
    fontSize: 20,
    '&:not(:first-of-type)': {
      marginLeft: 8,
    },
  },
  '& .icon-btn-eye': {
    border: `solid 1px ${alpha(theme.palette.primary.main, 1.0)}`,
    color: alpha(theme.palette.primary.main, 1.0),
  },
  '&:hover': {
    '& .icon-btn': {
      border: `solid 1px #F84E4E`,
      color: '#F84E4E',
    },

    '& .icon-btn-eye': {
      border: `solid 1px ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
    '& .disable-icon-btn-eye': {
      border: `solid 1px #b5ccd9`,
      color: '#b5ccd9',
    },
  },
}));
const TableItem = ({ data, verbiageSettings }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const handleEditClick = () => {
    setIsEditModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsEditModalOpen(false);
  };
  return (
    <TableRow key={data.name} className='item-hover'>
      <StyledTableCell align='left' sx={{ textTransform: 'capitalize' }}>
        <Box className='textwrap'>{data.waiver_name}</Box>
      </StyledTableCell>
      <StyledTableCell align='left' style={{ textTransform: 'capitalize' }}>
        {data.description.substring(0, 40)}...
      </StyledTableCell>
      <StyledTableCell align='left' style={{ textTransform: 'capitalize' }}>
        <Box className='textwrap'>
          {data.first_name} {data.last_name}
        </Box>
      </StyledTableCell>
      <StyledTableCell align='left' style={{ textTransform: 'capitalize' }}>
        {moment(data?.created_at).format('MMM D, YYYY')}
      </StyledTableCell>
      <StyledTableCell align='center'>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconButton
            size='small'
            className='icon-btn icon-btn-eye'
            onClick={handleEditClick}
          >
            <AiFillEye />
          </IconButton>
        </div>
      </StyledTableCell>
      {isEditModalOpen && (
        <ViewWaiverLog
          waiverLogData={data}
          isOpen={isEditModalOpen}
          onClose={handleCloseModal}
          verbiageSettings={verbiageSettings}
        />
      )}
    </TableRow>
  );
};

export default TableItem;

TableItem.propTypes = {
  data: PropTypes.object.isRequired,
  verbiageSettings: PropTypes.string,
};
